const testingTool = {
  header: 'Outil de test de contrôleur',
  serial_number: 'Numéro de série',
  site_id: 'ID du site',
  site_name: 'Nom du site',
  validation_code: 'Code de validation',
  assign_to_site: 'Attribuer au site',
  xml_command: 'Commande XML',
  send_command: 'Envoyer la commande',
  remove_site: 'Supprimer le site',
  panel_alive: 'panneau en direct',
  last_signal: 'Dernier signal',
  received: 'Reçu',
  sent: 'Envoyer',
  msg_in_memory: 'Messages en mémoire',
  log: 'Inscription',
  copy_clip: 'Copier dans le Presse-papiers',
  reset_msg:
    'Appuyez sur le bouton Confirmer pour réinitialiser le contrôleur aux paramètres d’usine. \n Appuyez sur Annuler si vous souhaitez dissocier le contrôleur du site.',
  btn_factory_reset: 'Réinitialiser et supprimer',
  btn_unassign: 'Seulement supprimer',
  ping_response_from_serial: 'Réponse ping du numéro de série :',
  assign_site_label: 'Attribuer le site :',
  ping_label: 'Ping :',
  unassign_site_label: 'Dissocier le site :',
  command_label: 'Commande :',
  key_label: 'Clé :',
};

export default testingTool;
